import { cloneDeep } from "lodash"
const dataTemplate = {

  '分析图像': [
    {
      '原始图像': [
        {
          name: 'brain_segmentation_image',
          type: 'onlyImage',
          imageSize: '21x29.7cm/2480x3508像素',
          iamgeNum: 'dynamic',
          imageList: [
            {
              name: '',
              url: ''
            },
            {
              name: 'addImageSeize',
              url: ''
            }
          ]
        }
      ],
      '人工智能多模态分析图': [
        {
          name: 'artificial_intelligence_multimodal_analysis_diagram_image',
          type: 'onlyImage',
          imageSize: '21x29.7cm/2480x3508像素',
          iamgeNum: 'dynamic',
          imageList: [
            {
              name: '',
              url: ''
            },
            {
              name: 'addImageSeize',
              url: ''
            }
          ]
        }
      ]
    }
  ]
}


function createParams(reportData) {
  let params = {
    "Brain_Segmentation_Image": {
      "img": []
    },
    "Artificial_Intelligence_Multimodal_Analysis_Diagram": {
      "img": []
    }
  }
  let bsImageListObj = reportData['分析图像'][0]['原始图像'][0]
  for (let i = 0; i < bsImageListObj.imageList.length; i++) {
    let item = bsImageListObj.imageList[i]
    if (!item.url) continue
    params.Brain_Segmentation_Image.img.push(item.url)
  }
  let aiImageListObj = reportData['分析图像'][0]['人工智能多模态分析图'][0]
  for (let i = 0; i < aiImageListObj.imageList.length; i++) {
    let item = aiImageListObj.imageList[i]
    if (!item.url) continue
    params.Artificial_Intelligence_Multimodal_Analysis_Diagram.img.push(item.url)
  }
  return params
}

function parseJsonObj(jsonObj) {
  let reportData = cloneDeep(dataTemplate)
  let aiImageList = jsonObj.Artificial_Intelligence_Multimodal_Analysis_Diagram.img || []
  reportData['分析图像'][0]['人工智能多模态分析图'][0]['imageList'].splice(0, 1)
  for (let i  = 0; i < aiImageList.length; i++) {
    let index = reportData['分析图像'][0]['人工智能多模态分析图'][0]['imageList'].length - 2
    let obj = {
      url: aiImageList[i],
      name: `artificial_intelligence_multimodal_analysis_diagram_image${i+1}`
    }
    reportData['分析图像'][0]['人工智能多模态分析图'][0]['imageList'].splice(index, 0, obj)
  }
  let bsImageList = jsonObj.Brain_Segmentation_Image.img || []
  reportData['分析图像'][0]['原始图像'][0]['imageList'].splice(0, 1)
  for (let i  = 0; i < bsImageList.length; i++) {
    let index = reportData['分析图像'][0]['原始图像'][0]['imageList'].length - 2
    let obj = {
      name: `brain_segmentation_image_${i+1}`,
      url: bsImageList[i]
    }
    reportData['分析图像'][0]['原始图像'][0]['imageList'].splice(index, 0, obj)
  }
  return reportData
}



export default {dataTemplate, createParams, parseJsonObj, reportType: 'Cranial_Neurovascular_AI_Analysis'}